var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.imageList),function(item,index){return _c('div',{key:index,class:_vm.isDouble?'biserial':'single_row'},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item),expression:"item"}],staticClass:"img"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }